// Section 17: priority group 'Newcomers'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function newcomers(_config: Config) {
  return definePriorityGroup({
    id: 'newcomers',
    label: 'Newcomers',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter(
          (p) =>
            p.arrivedTurn !== null &&
            ctx.season.turn - p.arrivedTurn <= ctx.cfg.migration.newcomerSeasons,
        )
        .map((p) => p.id),
  });
}
